import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cir-pub-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ArchiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
